import { useTranslation } from 'react-i18next';
import type { LeadCloudFileType, TaskCardType } from '@econtractor/types';
import { getTaskCardFileBuckets } from '../helpers/splitTaskFiles';
import TaskCardFiles from './TaskCardFiles';

interface TaskCardFilesTabProps {
    task: TaskCardType;
    onTaskUpdated: (task: TaskCardType) => void;
}

const TaskCardFilesTab = ({ task, onTaskUpdated }: TaskCardFilesTabProps) => {
    const { t } = useTranslation(['Tasks']);
    const { files, answerFiles } = getTaskCardFileBuckets(task);

    const handleFilesChange = async (nextFiles: LeadCloudFileType[]) => {
        onTaskUpdated({
            ...task,
            files: [...nextFiles, ...answerFiles],
        });
        return true;
    };

    return (
        <section className="task-card-section">
            {task.seriesTemplateId ? (
                <p className="text-muted fs-12 mb-2">{t('recurrent.filesShared')}</p>
            ) : null}
            <div className="task-card-section__label">
                {t('labelFiles')}
                {files.length > 0 ? ` (${files.length})` : ''}
            </div>
            <div className="task-card-panel">
                <TaskCardFiles
                    taskId={task.ID}
                    files={files}
                    canEdit
                    onFilesChange={handleFilesChange}
                />
            </div>
        </section>
    );
};

export default TaskCardFilesTab;
